import { Navigate, Route, Routes } from "react-router-dom";
import PaymentPage from "./pages/PaymentPage.jsx";
import SignupPage from "./pages/SignupPage.jsx";
import SuccessPage from "./pages/SuccessPage.jsx";

export default function App() {
  return (
    <div className="app">
      <header className="app__header">
        <span className="app__brand">EquiDeFi</span>
        <span className="app__tag">Stripe Connect Demo</span>
      </header>

      <main className="app__main">
        <Routes>
          <Route path="/" element={<SignupPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
